module.exports = __webpack_public_path__ + "img/logo-morumbi.459c8ccf.svg";